import type { Grade, RescueRowDto } from '@coachrex/shared';

/** "Best chance first": value × grade weight (A 1 · B .75 · C .45 · D .15). Ungraded counts as C. */
const WEIGHT: Record<Grade, number> = { A: 1, B: 0.75, C: 0.45, D: 0.15 };
const chance = (r: RescueRowDto) => (r.value && r.value > 0 ? r.value : 1) * WEIGHT[r.grade ?? 'C'];

export const byBestChance = (a: RescueRowDto, b: RescueRowDto) => chance(b) - chance(a);
